import PageWrapper from "../components/animations/PageWrapper";
import AnimatedCard from "../components/ui/AnimatedCard";
import CardHeader from "../components/ui/CardHeader";
import CardDetails from "../components/ui/CardDetails";
import Accordion from "../components/ui/Accordion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Projets() {
  const projetsUniversitaires = [
    {
      title: "PIC Machine Learning",
      entreprise: "ENEDIS",
      meta: "12 semaines - Janvier à Mai 2025",
      description:
        "Projet professionnalisant pour l'entreprise ENEDIS. Nous avons utilisé la méthodologie Scrum pour nous organiser afin de mettre en place un modèle permettant de prédire la consommation électrique en fonction de la météo.",
      details: [
        { label: "Langage utilisé", value: "Python" },
        { label: "Librairies utilisées", value: "Pandas, PyTorch, NumPy, Matplotlib" },
        { label: "Rôles", value: "Responsable Git, Développeur" },
        { label: "Taille de l'équipe", value : "9"}
      ],
    },
    {
      title: "Sandbox ITIkart",
      meta: "1 semestre - Septembre à Décembre 2024",
      description:
        "Utilisation d'un bac à sable SARndbox afin de créer et d'afficher un terrain pour une carte de jeu type Mariokart.",
      details: [
        { label: "Langages utilisés", value: "Python, C++" },
        { label: "Rôle", value: "Développeur" },
        { label: "Taille de l'équipe", value : "3"}
      ],
    },
    {
      title: "Robot Suiveur de ligne",
      meta: "1 semestre - Septembre à Décembre 2023",
      description:
        "Construction d'un robot et programmation de l'algorithme lui permettant de suivre des lignes à l'aide d'une Raspberry Pi.",
      details: [
        { label: "Langage utilisé", value: "C" },
        { label: "Rôle", value: "Développeur" },
        { label: "Taille de l'équipe", value : "4"}
      ],
    },
    {
      title: "Compresseur de Huffman",
      meta: "2 mois - Octobre à Décembre 2023",
      description:
        "Implémentation en équipe du compresseur de Huffman.",
      details: [
        { label: "Langage utilisé", value: "C" },
        { label: "Rôle", value: "Développeur" },
        { label: "Taille de l'équipe", value : "8"}
      ],
    },
  ];

  const projetsPerso = [
    {
      title: "Lyngarr's Wandering Pets",
      meta: "GitHub",
      metaLink: "https://github.com/Lyngarr/lyngarrwanderingpets",
      description:
        "Mod Minecraft Java client-side pour enrichir l'interaction avec les animaux domestiques.",
      details: [
        { label: "Langage utilisé", value: "Java" }
      ],
    },
    {
      title: "Ce site Web",
      meta: "Vous êtes ici",
      metaLink: "https://ulysse-gillotletang.fr/projets",
      description:
        "Montage réseau d'un serveur personnel afin de pouvoir mettre en ligne ce site web.",
      details: [
        { label: "Langages utilisés", value: "JavaScript, HTML, CSS" },
        { label: "Framework utilisé", value: "ReactJS" }
      ],
    },
    {
      title: "Concert de l'AMIR",
      meta: "Vidéo Youtube",
      metaLink: "https://youtu.be/uNH0XqZd5RM",
      description:
        "Organisation d'une interprétation de Merry-Go-Round Life de Joe Hisaishi pour le concert de l'Association des Musiciens de l'INSA de Rouen.",
      details: [
        { label: "Taille du groupe", value: "2" },
        { label: "Rôle", value: "Pianiste" }
      ],
    },
    {
      title: "Concert Talent Show",
      meta: "Vidéo Youtube",
      metaLink: "https://www.youtube.com/watch?v=JnS85cllVjw",
      description:
        "Organisation d'une interprétation de Traveler's encore de Andrew Prahlow pour le Talent Show de l'INSA.",
      details: [
        { label: "Taille du groupe", value: "8" },
        { label: "Rôles", value: "Organisateur, Pianiste" }
      ],
    },
  ];

  return (
    <main className="page-content">
      <PageWrapper>
        <section id="projets">
          <Link to="/accueil" className="back-link" aria-label="Retour à l'accueil">
            <ArrowLeft size={18} />
            <span>Accueil</span>
          </Link>
          <h2>Projets</h2>

          <Accordion title="Universitaires">
            {projetsUniversitaires.map((p, i) => (
              <AnimatedCard key={i}>
                <CardHeader title={p.title} subtitle={p.entreprise} meta={p.meta} />
                <p>{p.description}</p>
                <CardDetails details={p.details} />
              </AnimatedCard>
            ))}
          </Accordion>

          <Accordion title="Personnels">
            {projetsPerso.map((p, i) => (
              <AnimatedCard key={i}>
                <CardHeader title={p.title} meta={p.meta} metaLink={p.metaLink} />
                <p>{p.description}</p>
                <CardDetails details={p.details} />
              </AnimatedCard>
            ))}
          </Accordion>
        </section>
      </PageWrapper>
      </main>
  );
}